import React from "react";
import { Link } from "react-router-dom";
import Avatar from "../shared/Avatar";
import SafeImage from "../shared/SafeImage.jsx";
import RecommendedBadge from "../shared/RecommendedBadge";
import { Users, Eye, Clock, ArrowRight, Send, Disc3 } from "lucide-react";
import { Button } from "../ui/button";

const GigCard = ({ gig, index, inviteMode, openInviteModal, navigate }) => {
  return (
    <div key={gig.id} className="relative">
      <Link
        to={inviteMode ? "#" : `/gig/${gig.id}`}
        className="gig-card gig-card-glow card-shine group fade-in-up block"
        style={{ animationDelay: `${index * 0.05}s`, opacity: 0 }}
        data-testid={`gig-card-${gig.id}`}
        onClick={inviteMode ? (e) => e.preventDefault() : undefined}
      >
        <div className="relative h-48 overflow-hidden">
          <SafeImage
            src={gig.image_url}
            alt={gig.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            fallback={
              <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#1C1C1C] via-[#121212] to-[#0A0A0A] group-hover:scale-105 transition-transform duration-300">
                <Disc3 className="w-12 h-12 text-[#CCFF00]/25" />
              </div>
            }
          />
          <div className={`absolute top-3 left-3 px-3 py-1 text-xs font-bold uppercase bg-zinc-800 text-white`}>
            {gig.platform}
          </div>
          {inviteMode && (
            <div className="absolute top-3 right-3">
              <Button
                onClick={(e) => openInviteModal(gig, e)}
                size="sm"
                className="bg-[#CCFF00] text-black hover:bg-[#B8E600] font-bold"
              >
                <Send className="w-4 h-4 mr-1" />
                INVITE
              </Button>
            </div>
          )}
        </div>
        <div className="p-4 flex flex-col h-[calc(100%-12rem)]">
          <h3 className="font-['Syne'] font-bold text-lg mb-1 line-clamp-2">{gig.title}</h3>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (gig.promoter_id) navigate(`/promoter/${gig.promoter_id}`);
            }}
            className="flex items-center gap-2 text-sm text-zinc-500 mb-3 hover:text-[#CCFF00] transition-colors text-left"
            data-testid={`gig-promoter-link-${gig.id}`}
          >
            <Avatar src={gig.promoter_profile_picture} name={gig.promoter_name} size="xs" />
            <span>
              by <span className="underline-offset-2 hover:underline">{gig.promoter_name}</span>
            </span>
            {gig.promoter_recommended && <RecommendedBadge />}
          </button>
          <div className="flex items-center gap-4 text-xs text-zinc-500 mb-4">
            {gig.followers_count && (
              <span className="flex items-center gap-1">
                <Users className="w-3 h-3" />
                {(gig.followers_count / 1000).toFixed(0)}K
              </span>
            )}
            {gig.avg_views && (
              <span className="flex items-center gap-1">
                <Eye className="w-3 h-3" />
                {(gig.avg_views / 1000).toFixed(0)}K avg
              </span>
            )}
            <span className="flex items-center gap-1">
              <Clock className="w-3 h-3" />
              {gig.delivery_days}d
            </span>
          </div>
          {Array.isArray(gig.tags) && gig.tags.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mb-4" data-testid={`gig-tags-${gig.id}`}>
              {gig.tags.slice(0, 3).map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    navigate(`/marketplace?search=${encodeURIComponent(tag)}`);
                  }}
                  className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-[#CCFF00]/10 text-[#CCFF00] hover:bg-[#CCFF00] hover:text-black transition-colors"
                  data-testid={`gig-tag-${tag}`}
                >
                  #{tag}
                </button>
              ))}
            </div>
          )}
          <div className="mt-auto flex items-center justify-between">
            <span className="font-['Syne'] text-2xl font-bold">${gig.price}</span>
            {!inviteMode && (
              <span className="text-xs font-bold uppercase text-zinc-400 group-hover:text-black transition-colors flex items-center gap-1">
                View <ArrowRight className="w-3 h-3" />
              </span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default GigCard;
